import React, { Component, ErrorInfo, ReactNode } from 'react';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Error capturado en ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className={styles.container} role="main">
          <section className={styles.content}>
            <h1 className={styles.title}>
              <span className={styles.code}>Error</span>
              <span className={styles.divider}>|</span>
              <span>Algo salió mal</span>
            </h1>
            
            <p className={styles.message}>
              Intenta refrescar la página o vuelve más tarde.
            </p>
            
            <button 
              onClick={() => window.location.replace(window.location.href)} 
              className={styles.button}
            >
              Refrescar página
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;